import { render, staticRenderFns } from "./ProductDropDown.vue?vue&type=template&id=58259cc6&scoped=true&"
import script from "./ProductDropDown.vue?vue&type=script&lang=js&"
export * from "./ProductDropDown.vue?vue&type=script&lang=js&"
import style0 from "./ProductDropDown.vue?vue&type=style&index=0&id=58259cc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58259cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
